import { Router } from '@angular/router';

/**
 * Close on the ILP and progress report screens: back to the page the user came from — the tutor
 * reports page or the timeline.
 *
 * Back, not a fresh navigation: the timeline is built from navigation state its URL does not carry,
 * and a plain navigate to /timeline/:id sends the user to their landing page. Going back restores
 * that state. A screen opened cold (a deep link or a refresh) has nothing in the app to go back to,
 * so it goes to the booking's tutor reports page, which its URL alone is enough to open.
 */
export function returnToPreviousPage(router: Router, placementId: number): void {
  // The router numbers each navigation in history.state; 1 is the navigation that loaded the app.
  const navigationId = window.history.state?.navigationId ?? 0;
  if (navigationId > 1) {
    window.history.back();
  } else {
    router.navigate(['/tutorreports', placementId]);
  }
}
